<template lang="pug">
v-card.pa-6.mb-6.rounded-lg(outlined)
  v-row(no-gutters)
    v-col
      document-header-info(:parentData="parentData" :selectedDocument="selectedDocument")
    v-divider.mx-8(vertical)
    v-col
      document-header-status(:parentData="parentData" :selectedDocument="selectedDocument" @updated="$emit('updated')" @invoiceStatusChanged="$emit('invoiceStatusChanged', $event)")
    v-divider.mx-8(vertical)
    v-col
      document-header-stock(:parentData="parentData" :selectedDocument="selectedDocument" :selectedItems="selectedItems" @updatedRequestStock="$emit('updatedRequestStock')")
    v-divider.mx-8(vertical)
    v-col
      document-header-outstanding-balance(:parentData="parentData" :selectedDocument="selectedDocument" :dueAmount="dueAmount" @updated="$emit('updated')")
</template>

<script>
import DocumentHeaderInfo from '@/components/clinic/purchasehub/document/documentheader/DocumentHeaderInfo.vue'
import DocumentHeaderStatus from '@/components/clinic/purchasehub/document/documentheader/DocumentHeaderStatus.vue'
import DocumentHeaderStock from '@/components/clinic/purchasehub/document/documentheader/DocumentHeaderStock.vue'
import DocumentHeaderOutstandingBalance from '@/components/clinic/purchasehub/document/documentheader/DocumentHeaderOutstandingBalance.vue'

export default {
  components: {
    DocumentHeaderInfo, DocumentHeaderStatus, DocumentHeaderStock, DocumentHeaderOutstandingBalance
  },
  props: {
    parentData: {
      type: Object,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    dueAmount: {
      type: Number,
      default: 0
    }
  },
}
</script>

<style scoped>

</style>